<template>
  <v-container fluid align-start ma-0 pa-2 class="epms2000-main container-height">
    <v-row no-gutters fill-height>
      <v-col cols="12">
        <i-card-vertical :headerTitle="menuTitle" >
          <template v-slot:body>
            <v-row>
              <v-col cols="12" class="pa-0">
                <i-card-top
                  class="d-md-flex"
                  outlined
                >
                  <!-- :useBtnList="[
                    'btnSearch'
                  ]"
                  @btnSearch="btnSearch()" -->
                  <template v-slot:body>
                    <v-row no-gutters class="center pa-2">
                      <i-label :label="'Material Division : '"/>
                      <v-col cols="2">
                        <v-select
                          v-model="selectedMat"
                          :items="matList"
                          return-object
                          item-text="codeName"
                          item-value="code"
                          single-line
                          outlined
                          dense
                          height="32"
                          @change="btnSearch" />
                      </v-col>

                      <i-label :label="'Receive : '" class="pl-2"/>
                      <v-col cols="2">
                        <v-select
                            v-model="selectedRcv"
                            :items="rcvList"
                            return-object
                            item-text="codeName"
                            item-value="code"
                            single-line
                            outlined
                            dense
                            height="32"
                            @change="btnSearch" />
                      </v-col>

                      <i-label :label="'Submit : '" class="pl-2"/>
                      <v-col cols="2">
                        <v-select
                            v-model="selectedSbm"
                            :items="sbmList"
                            return-object
                            item-text="codeName"
                            item-value="code"
                            single-line
                            outlined
                            dense
                            height="32"
                            @change="btnSearch" />
                      </v-col>
                    </v-row>
                  </template>
                </i-card-top>
              </v-col>
            </v-row>

            <v-row no-gutters class="pt-1">
              <v-col cols="12" class="pa-0">
                <DxDataGrid
                  :class="[dataList2.length > 0 ? '' : 'listBox']"
                  :height="dataList2.length > 0 ? '500px' : ''"
                  :ref="epms2000Ref"
                  :data-source="dataList" 
                  :remote-operations="false" 
                  :hover-state-enabled="true"
                  :allow-column-resizing="true" 
                  :allow-column-reordering="true"
                  :row-alternation-enabled="true" 
                  :show-borders="true" 
                  :width="grid.width"
                  :show-row-lines="true" 
                  key-expr="id" 
                  :focused-row-enabled="true"
                  :column-hiding-enabled="false" 
                  :selection="{ mode: 'none' }"
                  @cellPrepared="cellPrepared"
                >
                  <DxColumn data-field="id" caption="No" width="5%" data-type="string" alignment="center" :visible="true" :allow-editing="false" />
                  <DxColumn data-field="quotNo" caption="Quotation No" width="10%" data-type="string" alignment="center" :visible="true" cell-template="quotNoTemplate" :allow-editing="false" />
                  <template #quotNoTemplate="{ data }">
                    <v-btn small elevation="0" color="transparent" class="px-1 py-0 grd-btn" @click="goDetail(data)" >
                      {{ data.value }}
                    </v-btn>
                  </template>
                  <DxColumn data-field="buyerNm" caption="Purchase Charger" width="15%" data-type="left" alignment="center" :visible="true"  :allow-editing="false"/>
                  <DxColumn data-field="quotTitle" caption="Title" width="30%" data-type="string" alignment="left" :visible="true" cell-template="quotTitleTemplate" :allow-editing="false" />
                  <template #quotTitleTemplate="{ data }">
                    <v-btn small elevation="0" color="transparent" class="px-1 py-0 grd-btn" @click="goDetail(data)" >
                      {{ data.value }}
                    </v-btn>
                  </template>
                  <DxColumn data-field="startDte" caption="P/I Start Time" width="10%" data-type="string" alignment="center" :visible="true" :allow-editing="false" />
                  <DxColumn data-field="finishDte" caption="P/I Finish Time" width="10%" data-type="string" alignment="center" :visible="true" :allow-editing="false" />
                  <DxColumn data-field="receiveYn" caption="Recieve" width="8%" alignment="center" :visible="true" cell-template="recieveTemplate" :allow-editing="false" />
                  <template #recieveTemplate="{ data }">
                    <template v-if="data.value === 'Y'">
                      <v-icon small class="mt-n1" color="blue" >
                        mdi-checkbox-marked-circle
                      </v-icon>
                    </template>
                    <template v-else>
                      <v-btn small elevation="0" color="transparent" class="px-1 py-0 grd-btn" @click.stop="receiveQuot(data.data)">
                        <v-icon small class="mt-n1">
                          mdi-arrow-right-box
                        </v-icon>
                        Recieve
                      </v-btn>
                    </template>
                  </template>
                  <DxColumn data-field="submitYn" caption="Submit" width="8%" data-type="string" alignment="center" :visible="true"  cell-template="submitTemplate" :allow-editing="false" />
                  <template #submitTemplate="{ data }">
                    <template v-if="data.value === 'Y'">
                      <v-icon small class="mt-n1" color="blue" >
                        mdi-checkbox-marked-circle
                      </v-icon>
                    </template>
                    <template v-else>
                      <v-btn small elevation="0" color="transparent" class="px-1 py-0 grd-btn" @click.stop="makeQuot(data.data)">
                        <v-icon small class="mt-n1">
                          mdi-arrow-right-box
                        </v-icon>
                        Make
                      </v-btn>
                    </template>
                  </template>
                  <DxColumn data-field="" caption="View Sheet" width="12%" data-type="string" alignment="center" :visible="true" cell-template="viewSheetTemplate" :allow-editing="false" />
                    <template #viewSheetTemplate="{ data }">
                      <div>
                        <v-btn small elevation="0" color="transparent" class="px-1 py-0 grd-btn" @click.stop="showReport('POR', data.data)">
                          <v-icon small class="mt-n1">
                            mdi-arrow-right-box
                          </v-icon>
                          POR
                        </v-btn>

                        <v-btn small elevation="0" color="transparent" class="px-1 py-0 grd-btn" @click.stop="showReport('BOM', data.data)">
                          <v-icon small class="mt-n1">
                            mdi-arrow-right-box
                          </v-icon>
                          BOM
                        </v-btn>
                      </div>
                    </template>
                </DxDataGrid>

                <i-card-vertical v-show="dataList2.length > 0" :headerTitle="'Waste Selling Quotation List'" >
                    <template v-slot:body>
                        <v-row>
                          <v-col cols="12" class="pa-0">
                            <DxDataGrid
                              :ref="epms2000Ref2"
                              :data-source="dataList2" 
                              :remote-operations="false" 
                              :hover-state-enabled="true"
                              :allow-column-resizing="true" 
                              :allow-column-reordering="true"
                              :row-alternation-enabled="true" 
                              :show-borders="true" 
                              :width="grid.width"
                              :show-row-lines="true" 
                              key-expr="id" 
                              :focused-row-enabled="true"
                              :column-hiding-enabled="false" 
                              :selection="{ mode: 'none' }"
                              :word-wrap-enabled="true"
                              @cellPrepared="cellPrepared"
                            >
                              <DxColumn data-field="id" caption="No" width="3%" data-type="string" alignment="center" :visible="true" :allow-editing="false" />
                              <DxColumn data-field="quotNo" caption="Quotation No" width="8%" data-type="string" alignment="center" :visible="true" cell-template="quotNoTemplate" :allow-editing="false" />
                              <template #quotNoTemplate="{ data }">
                                <v-btn small elevation="0" color="transparent" class="px-1 py-0 grd-btn" @click.stop="goDetail(data)" >
                                  {{ data.value }}
                                </v-btn>
                              </template>
                              <DxColumn data-field="buyerNm" caption="Purchase Charger" width="15%" data-type="left" alignment="center" :visible="true" :allow-editing="false" />
                              <DxColumn data-field="quotTitle" caption="Title" data-type="string" alignment="left" :visible="true" cell-template="quotTitleTemplate" :allow-editing="false" />
                              <template #quotTitleTemplate="{ data }">
                                <!-- <v-btn small elevation="0" color="transparent" class="px-1 py-0 grd-btn" @click.stop="goDetail(data)" >
                                  {{ data.value }}
                                </v-btn> -->
                                <span class="text-hover bold-hover cursor-pointer" @click.stop="goDetail(data)">
                                  {{ data.value }}
                                </span>
                              </template>
                              <DxColumn data-field="startDte" caption="Start Time" width="8%" data-type="string" alignment="center" :visible="true" :allow-editing="false" />
                              <DxColumn data-field="finishDte" caption="Finish Time" width="8%" data-type="string" alignment="center" :visible="true" :allow-editing="false" />
                              <DxColumn data-field="receiveYn" caption="Recieve" width="6%" alignment="center" :visible="true" cell-template="recieveTemplate" :allow-editing="false" />
                              <template #recieveTemplate="{ data }">
                                <template v-if="data.value === 'Y'">
                                  <v-icon small class="mt-n1" color="blue" >
                                    mdi-checkbox-marked-circle
                                  </v-icon>
                                </template>
                                <template v-else>
                                  <v-btn small elevation="0" color="transparent" class="px-1 py-0 grd-btn" @click.stop="receiveQuot(data.data)">
                                    <v-icon small class="mt-n1">
                                      mdi-arrow-right-box
                                    </v-icon>
                                    Recieve
                                  </v-btn>
                                </template>
                              </template>
                              <DxColumn data-field="submitYn" caption="Submit" width="6%" data-type="string" alignment="center" :visible="true"  cell-template="submitTemplate" :allow-editing="false" />
                              <template #submitTemplate="{ data }">
                                <template v-if="data.value === 'Y'">
                                  <v-icon small class="mt-n1" color="blue" >
                                    mdi-checkbox-marked-circle
                                  </v-icon>
                                </template>
                                <template v-else>
                                  <v-btn small elevation="0" color="transparent" class="px-1 py-0 grd-btn" @click.stop="makeQuot(data.data)">
                                    <v-icon small class="mt-n1">
                                      mdi-arrow-right-box
                                    </v-icon>
                                    Make
                                  </v-btn>
                                </template>
                              </template>
                              <DxColumn data-field="" caption="View Sheet" width="10%" data-type="string" alignment="center" :visible="true" cell-template="viewSheetTemplate" :allow-editing="false" />
                                <template #viewSheetTemplate>                                 
                                </template>
                            </DxDataGrid>
                          </v-col>
                        </v-row>
                    </template>
                  </i-card-vertical>

              </v-col>
            </v-row>
          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import notify from 'devextreme/ui/notify'
import baseview from '@/components/base/baseview.vue'
import BaseDataGrid from '@/components/base/BaseDataGrid.vue'
import { getCmChildCode } from '@/api/system/cmCodeManage'
import { getRequestList, getWasteSellList, goReceive } from '@/api/view/hip/common/common.js'
import { reportView } from '@/api/view/hip/common/common.js'

export default {
  name: 'epms2000',
  mixins: [baseview, BaseDataGrid],
  data() {
    return {
      epms2000Ref: 'epms2000Ref',
      epms2000Ref2: 'epms2000Ref2',
      menuTitle: this.$route.meta.title,
      dataList: [],
      dataList2: [],
      matList: [],
      selectedMat: null,
      rcvList: [],
      selectedRcv: null,
      sbmList: [],
      selectedSbm: null
    }
  },
  computed: {
    gridInstance() {
      return this.GetDataGrid(this.epms2000Ref)
    },
    grid2Instance() {
      return this.GetDataGrid(this.epms2000Ref2)
    }
  },
  methods: {
    async bindingCombo() {
      await this.bindingMat()
      await this.bindingRcv()
      await this.bindingSbm()
    },
    async bindingMat() {
      await getCmChildCode({
        code: '',
        codegr: '',
        prtCode: 'MAT_DIV',
        userFlag: 'Y'
      }).then(res => {
        // console.log('res', res)

        this.matList = res.list
        this.matList.unshift({
          code: '',
          codeName: 'All'
        })
        this.selectedMat = this.matList[0]
      })
    },
    async bindingRcv() {
      await getCmChildCode({
        code: '',
        codegr: '',
        prtCode: 'RCV_DIV',
        userFlag: 'Y'
      }).then(res => {
        // console.log('res', res)

        this.rcvList = res.list
        this.rcvList.unshift({
          code: '',
          codeName: 'All'
        })
        this.selectedRcv = this.rcvList[0]
      })
    },
    async bindingSbm() {
      await getCmChildCode({
        code: '',
        codegr: '',
        prtCode: 'SBM_DIV',
        userFlag: 'Y'
      }).then(res => {
        // console.log('res', res)

        this.sbmList = res.list
        this.sbmList.unshift({
          code: '',
          codeName: 'All'
        })
        this.selectedSbm = this.sbmList[0]
      })
    },
    init() {
      this.dataList = []
      this.dataList2 = []
      this.gridInstance.clearSelection()
      this.grid2Instance.clearSelection()
    },
    async btnSearch() {
      this.init()
      this.openLoading('searching')

      const param = {
        makerCd: this.$store.state.user.makerCd,
        quotStep: 'B',
        receiveYn: this.selectedRcv.code,
        submitYn: this.selectedSbm.code,
        matlDiv: this.selectedMat.code,
        userId: this.$store.state.user.userId,
      }

      // console.log('param', param)

      await getRequestList(param).then(res => {
        // console.log('res', res)

        this.dataList = res.list
      }).finally(() => {
        this.endLoading()
      })

      await getWasteSellList(param).then(res => {
        
        this.dataList2 = res.list
      }).finally(() => {
        this.endLoading()
      })
    },
    cellPrepared(e){
      if(e.rowType === 'data'){
        e.cellElement.style.padding = '1px 8px'
      }
    },
    goDetail(data) {
      const quotNo = data.data.quotNo

      this.$router.push({
        name: 'epms2010',
        params: {
          quotNo: quotNo
        }
      })
    },
    showReport(gbn, data) {
      // console.log('gbn', gbn)
      // console.log('data', data)

      let param = {
        as_quot_no: data.quotNo,
        as_maker_cd: this.$store.state.user.makerCd
      }

      if(gbn === 'POR') {
        param.fileName = 'por_sheet.jrxml'
      } else if(gbn === 'BOM') {
        param.fileName = 'bom_list.jrxml'
      } else {
        param.fileName = 'epms2010.jrxml'
      }

      // console.log('param', param)

      this.openLoading('searching')
      reportView(param)
      .finally(() => {
        this.endLoading()
      })
    },
    receiveQuot(data) {
      // console.log('data', data)

      this.vToastifyPrompt(
        this.$t('Do you want to receive the Quotation Request?'),
        'info',
        current => {
          this.openLoading('searching')

          const param = {
            quotNo: data.quotNo,
            makerCd: this.$store.state.user.makerCd
          }

          // console.log('param', param)

          goReceive(param).then(res => {
            // console.log('res', res)

            const msg = res.body
            if(msg === 'OK') {
              notify(this.$t('Receipt Quotation is completed.'), 'success', 3000)
              
              this.btnSearch()
              
              this.showReport('', data)
            } else {
              this.vToastify(this.$t(msg), 'warn')
            }
          }).catch(error => {
            this.vToastify(error, 'warn')
          }).finally(() => {
            this.endLoading()
          })
        },
        null,
        true
      )
    },
    makeQuot(data) {
       console.log('data', data)

      if(data.receiveYn && data.receiveYn !== 'Y') {
        this.vToastify(this.$t('The quotation is not yet received'), 'warn')
        return
      } else {
        const quotNo = data.quotNo
        const makerCd = this.$store.state.user.makerCd//data.makerCd
        const custDiv = data.custDiv
        const matlDiv = data.matlDiv
       
        let routerNm = ''

        console.log(matlDiv)

        if(matlDiv === 'L') {          
          routerNm = 'epms2030'
        }  
         else if(matlDiv === 'O'){
            routerNm = 'epms2040'  
        } else {
          if(quotNo.includes('WM')){
            routerNm = 'epms2020_waste'
          }else{
            routerNm = 'epms2020'
          }          
        }

        this.$router.push({
          name: routerNm,
          params: {
            quotNo: quotNo
          }
        })
      }
    }
  },
  async mounted() {
    await this.bindingCombo()
    await this.btnSearch()
  }
}
</script>

<style lang="scss" scoped>
.epms2000-main {
  .subTitle {
    font-weight: bold;
    color: black;
  }

  .grd-btn {
    text-transform: unset !important;
    font-weight: bold;
    // height: 16px !important;

    :hover  {
      color: #4980BC;
    }
  }
}
</style>